import api from "./api";

let currentAudio = null;

export function stopAudio() {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio = null;
  }
}

export async function fetchTTS(text, voice) {
  const { data } = await api.post("/tts", { text, voice }, { timeout: 25000 });
  return data.audio;
}

export async function fetchPublicTTS(text, voice) {
  const { data } = await api.post("/tts/public", { text, voice }, { timeout: 25000 });
  return data.audio;
}

export function playBase64(b64, onEnd) {
  stopAudio();
  const audio = new Audio(`data:audio/mp3;base64,${b64}`);
  currentAudio = audio;
  audio.onended = () => {
    currentAudio = null;
    onEnd && onEnd();
  };
  const p = audio.play();
  if (p && p.catch) p.catch(() => { currentAudio = null; onEnd && onEnd(); });
  return audio;
}
